import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { IconSeeker } from "@ui-seeker/core"

import { renderSkuGroup } from '@signals'
import { useSkuGroupModal } from "../../@hooks"


export default function actionsColumn() {
	return {
		name: "value",
		setBodyCellProps: () => ({ sx: { textAlign: 'center' } }),
		render: value => <IconCell filterID={value} />
	}
}

function IconCell({ filterID }) {
	const { deleteSkuGroup } = useSkuGroupModal()
	const iconWeight = useSignal('regular')
	
	return <IconSeeker 
		icon='trash' 
		iconWeight={iconWeight}
		onMouseOver={() => iconWeight.value = 'solid'}
        onMouseLeave={() => iconWeight.value = 'regular'}
		onClick={() => {
			renderSkuGroup.value = false
			deleteSkuGroup(filterID)
		}} 
		tooltip="Delete SKU Group" 
		sx={{ '&:hover': { cursor: 'pointer' } }}
	/>
}